var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"user_section"},[_c('article',{staticClass:"view intro w1200"},[_c('div',[_c('div',{staticClass:"txt_box"},[_c('div',{staticStyle:{}},[_c('img',{staticClass:"w100",attrs:{"src":require("@/assets/img/layout/introduce_elephant.webp"),"alt":""}})])])])])])
}]

export { render, staticRenderFns }